"use strict";
/**
 * The type a file is by its first bytes (magic bytes), never by its name: the
 * images, icons and web fonts an App may ship and the images the platform
 * serves. An unknown pattern is `application/octet-stream`. Runs in the
 * browser and in Node alike.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE_SIGNATURE_BYTES = void 0;
exports.detectImageMime = detectImageMime;
/** The bytes the detection reads; a longer head changes nothing. */
exports.FILE_SIGNATURE_BYTES = 12;
const ascii = (bytes, start, end) => String.fromCharCode(...bytes.subarray(start, end));
function detectImageMime(bytes) {
    if (bytes[0] === 0x89 && bytes[1] === 0x50)
        return 'image/png';
    if (bytes[0] === 0xff && bytes[1] === 0xd8)
        return 'image/jpeg';
    if (bytes[0] === 0x47 && bytes[1] === 0x49)
        return 'image/gif';
    if (ascii(bytes, 0, 4) === 'RIFF' && ascii(bytes, 8, 12) === 'WEBP')
        return 'image/webp';
    if (ascii(bytes, 0, 5) === '<?xml' || ascii(bytes, 0, 4) === '<svg')
        return 'image/svg+xml';
    if (bytes[0] === 0x00 &&
        bytes[1] === 0x00 &&
        bytes[2] === 0x01 &&
        bytes[3] === 0x00)
        return 'image/x-icon';
    if (ascii(bytes, 0, 4) === 'wOFF')
        return 'font/woff';
    if (ascii(bytes, 0, 4) === 'wOF2')
        return 'font/woff2';
    return 'application/octet-stream';
}
